import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedName from 'I18n/components/FormattedName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import formatName from 'I18n/utils/formatName';
import { H2 } from 'UIComponents/elements/headings'; // @ts-expect-error missing type declaration

import UIAvatar from 'ui-addon-avatars/UIAvatar';

const TeamMemberFeatureInterest = ({
  interestedUsers,
  width = '60%'
}) => {
  const firstUserObjectWithName = interestedUsers.find(user => user.givenName && user.givenName.length > 0 && user.familyName && user.familyName.length);
  return /*#__PURE__*/_jsxs("div", {
    className: "justify-between m-bottom-12",
    children: [/*#__PURE__*/_jsx(H2, {
      style: {
        fontWeight: '600',
        width,
        alignSelf: 'center',
        marginBottom: 0
      },
      "aria-level": 2,
      className: interestedUsers && interestedUsers.length ? 'm-right-6' : '',
      children: firstUserObjectWithName && interestedUsers.length > 1 ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "ebxInterstitialPage.teamInterestSection.headerWithOtherUsers",
        options: {
          name: /*#__PURE__*/_jsx(FormattedName, {
            givenName: firstUserObjectWithName.givenName,
            familyName: firstUserObjectWithName.familyName,
            isFriendly: true
          })
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ebxInterstitialPage.teamInterestSection.headerWithNoUsers"
      })
    }), !!interestedUsers.length && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIAvatar, {
        maxAvatars: 5,
        lookup: interestedUsers.map(({
          email,
          givenName,
          familyName
        }) => ({
          hubSpotUserEmail: email,
          displayName: formatName({
            firstName: givenName,
            lastName: familyName
          })
        })),
        size: "md"
      })
    })]
  });
};

export default TeamMemberFeatureInterest;